import { Box, Container, Divider, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

interface Props {
  to: string
  label: string
}
function LinkButton ({ to, label }: Props) {
  return (
    <Link
      to={to}
      className="
        px-12 py-8 min-w-[9.6rem]
        border-2 border-solid border-gray-50
        !text-gray-50 text-center
      "
    >
      {label}
    </Link>
  )
}

function FrontPage () {
  const { t } = useTranslation()

  const topLinks = [
    { label: t('GLOSSARY.ONE_WAY_SLAB'), to: '/one-way-slab' },
    { label: t('GLOSSARY.TWO_WAY_SLAB'), to: '/two-way-slab' },
    { label: t('GLOSSARY.BEAM'), to: '/beam' },
    { label: t('GLOSSARY.COLUMN'), to: '/column' },
  ]

  const bottomLinks = [
    { label: t('GLOSSARY.FOUNDATION'), to: '/foundation' },
    { label: t('GLOSSARY.BASEMENT_WALL'), to: '/basement-wall' },
    { label: t('GLOSSARY.WIND_TUNNEL_STUDY'), to: '/wind-tunnel-study' },
  ]

  return (
    <Box className="w-screen h-screen max-h-screen max-w-screen overflow-hidden">
      {/* 배경 이미지 */}
      <Box
        className="
          bg-cover bg-center bg-gray-50
          bg-[url('https://picsum.photos/1280/600')]
          object-cover bg-no-repeat brightness-[0.64] w-full h-full
          absolute -z-10
        "
      />
      {/* 점보트론 컨텐츠 */}
      <Container className="flex items-center justify-center mt-[12.5%]">
        <Box className="flex flex-col gap-24 items-center justify-center">
          {/* 타이틀 및 설명 */}
          <Box
            className="
              flex flex-col gap-24
              items-center justify-center
              text-center text-white w-full
            "
          >
            <Typography variant="h1">
              {t('COMPOUND.ARCHITECTURAL_PLANNER')}
            </Typography>
            <Divider className="w-full !border-white !border-2 !mb-2" />
            <Typography variant="subtitle1">
              {t('SENTENCE.FRONT_DESCRIPTION_1')}
              <br />
              {t('SENTENCE.FRONT_DESCRIPTION_2')}
            </Typography>
          </Box>
          {/* 각 메뉴로 이어지는 버튼 */}
          <Box className="flex gap-16">
            {topLinks.map(_ => (
              <LinkButton key={_.to} {..._} />
            ))}
          </Box>
          <Box className="flex gap-16">
            {bottomLinks.map(_ => (
              <LinkButton key={_.to} {..._} />
            ))}
          </Box>
        </Box>
      </Container>
    </Box>
  )
}

export default FrontPage
